import { __awaiter } from "tslib";
import { useCallback } from "react";
import * as thunkActions from "../actions";
import { useConfigurationDispatch } from "../context/ConfigurationReduxContext";
import { updateAttributeValue, } from "../reducers/actions";
/**
 * Hook that generates some convenience functions to avoid dispatch
 * requires `ConfigurationController`
 * @category Hook
 * @category CsConfiguration
 * @category API
 * @export
 * @returns
 */
export function useCsConfigurationApi() {
    const dispatch = useConfigurationDispatch();
    // discrete value update
    const setAttributeValue = useCallback((change) => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.setCfgValue(change));
    }), [dispatch]);
    // local discrete value update
    const setLocalAttributeValue = useCallback((change) => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(updateAttributeValue(change));
    }), [dispatch]);
    // discrete value update
    const setAttributeValues = useCallback((changes) => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.setCfgValues(changes));
    }), [dispatch]);
    // quantity change
    const setAttributeValueQuantity = useCallback((change) => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.setCfgValueQuantity(change));
    }), [dispatch]);
    const resetAttributes = useCallback((resets) => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.resetAttributes(resets));
    }), [dispatch]);
    const startConfiguration = useCallback((startOptions, asyncOptions) => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.startConfiguration(startOptions, asyncOptions));
    }), [dispatch]);
    const resumeConfiguration = useCallback((sessionId, resumeOptions, asyncOptions) => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.resumeConfiguration(sessionId, resumeOptions, asyncOptions));
    }), [dispatch]);
    const reloadConfiguration = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.reloadConfiguration());
    }), [dispatch]);
    const resetCurrentCfgObject = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.resetCurrentCfgObject());
    }), [dispatch]);
    const resetRootCfgObject = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.resetRootCfgObject());
    }), [dispatch]);
    const resetPath = useCallback((path) => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.resetSubCfgObject({ path }));
    }), [dispatch]);
    const saveConfiguration = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        return yield dispatch(thunkActions.saveConfiguration());
    }), [dispatch]);
    const loadConfiguration = useCallback((loadOptions, asyncOptions) => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.loadConfiguration(loadOptions, asyncOptions));
    }), [dispatch]);
    const fetchConfigurationUnits = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.fetchConfigurationUnits());
    }), [dispatch]);
    const fetchCurrencies = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.fetchCurrencies());
    }), [dispatch]);
    const commitConfiguration = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.commitConfiguration());
    }), [dispatch]);
    const rollbackConfiguration = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(thunkActions.rollbackConfiguration());
    }), [dispatch]);
    const invokeUserDefinedFunction = useCallback((params) => __awaiter(this, void 0, void 0, function* () {
        return yield dispatch(thunkActions.invokeUserDefinedFunctionSimple(params));
    }), [dispatch]);
    return {
        startConfiguration,
        resumeConfiguration,
        reloadConfiguration,
        setAttributeValue,
        setAttributeValues,
        setAttributeValueQuantity,
        resetAttributes,
        resetPath,
        resetCurrentCfgObject,
        resetRootCfgObject,
        saveConfiguration,
        loadConfiguration,
        setLocalAttributeValue,
        fetchConfigurationUnits,
        fetchCurrencies,
        commitConfiguration,
        rollbackConfiguration,
        invokeUserDefinedFunction,
    };
}
//# sourceMappingURL=useCsConfigurationApi.js.map